import { Image, Placeholder } from 'cloudinary-react';
import { array } from 'prop-types';

import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tiles from 'components/common/Tiles';
import { useState } from 'react';
import Modal from '../common/Modal';

const CampaignPagePhotoGalleryGrid = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const closeModal = () => setSelectedImage(null);

  return (
    <>
      {selectedImage && (
        <Modal
          show
          onHide={closeModal}
          className="!bg-transparent shadow-none !max-h-[95vh] h-screen flex justify-center items-center md:!max-w-none overflow-hidden"
        >
          <div className="relative h-[80vh] flex justify-center items-center">
            <div className="relative">
              <figure className="rounded-2xl overflow-hidden max-h-[600px] md:h-[600px]">
                <Image
                  publicId={selectedImage}
                  alt="photo-gallery"
                  width="auto"
                  height={1200}
                  crop="scale"
                  resize="limit"
                  quality="auto"
                  className="w-full h-full object-contain object-center"
                >
                  <Placeholder type="blur" />
                </Image>
              </figure>

              <button
                type="button"
                onClick={closeModal}
                className="w-8 h-8 flex justify-center items-center bg-white rounded-full absolute right-0 -top-10 text-xl text-gray-800 z-10"
              >
                <FontAwesomeIcon icon={faTimes} size="1x" />
              </button>
            </div>
          </div>
        </Modal>
      )}
      <div className="mt-10">
        <Tiles
          columns={[2, 3, 4]}
          spacing="sm"
          align="center"
          className="gap-y-1 sm:gap-y-3 "
          itemClassName="flex justify-center items-center"
        >
          {images.map((imageLink) => {
            return (
              <div
                key={imageLink}
                className="border-2 border-transparent rounded-2xl overflow-hidden hover:border-black transition-all duration-300 cursor-pointer"
                onClick={() => setSelectedImage(imageLink)}
              >
                <Image
                  publicId={imageLink}
                  alt=""
                  width={800}
                  height={800}
                  gravity="auto"
                  className="block w-full h-full object-cover object-center"
                  crop="fill"
                />
              </div>
            );
          })}
        </Tiles>
      </div>
    </>
  );
};

CampaignPagePhotoGalleryGrid.propTypes = {
  images: array.isRequired,
};

export default CampaignPagePhotoGalleryGrid;
